var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12046_12082)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 25.0278C19.4192 25.0278 25.0283 19.5155 25.0283 12.7156C25.0283 5.91571 19.4192 0.40332 12.5 0.40332C5.58082 0.40332 -0.0282745 5.91571 -0.0282745 12.7156C-0.0282745 19.5155 5.58082 25.0278 12.5 25.0278Z",
    fill: "url(#paint0_linear_12046_12082)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1611 5.87549H9.84356C7.47154 5.87549 5.54497 7.76884 5.54497 10.1V15.3258C5.54497 17.657 7.47154 19.5503 9.84356 19.5503H15.1611C17.5331 19.5503 19.4597 17.657 19.4597 15.3258V10.1C19.4597 7.76884 17.5331 5.87549 15.1611 5.87549ZM17.9062 15.3313C17.9062 16.8197 16.6756 18.0345 15.1555 18.0345H9.83799C8.32346 18.0345 7.08734 16.8252 7.08734 15.3313V10.1054C7.08734 8.61702 8.31789 7.40221 9.83799 7.40221H15.1555C16.6701 7.40221 17.9062 8.61155 17.9062 10.1054V15.3313Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.4995 9.21875C10.5396 9.21875 8.94151 10.7892 8.94151 12.7154C8.94151 14.6416 10.5396 16.2121 12.4995 16.2121C14.4595 16.2121 16.0576 14.6416 16.0576 12.7154C16.0576 10.7892 14.4595 9.21875 12.4995 9.21875ZM12.4995 14.8386C11.308 14.8386 10.3391 13.8865 10.3391 12.7154C10.3391 11.5444 11.308 10.5923 12.4995 10.5923C13.6911 10.5923 14.66 11.5444 14.66 12.7154C14.66 13.8865 13.6911 14.8386 12.4995 14.8386Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.329 9.60233C16.6568 9.5501 16.8794 9.24661 16.8263 8.92446C16.7732 8.60231 16.4644 8.38349 16.1366 8.43572C15.8088 8.48794 15.5861 8.79143 15.6392 9.11358C15.6924 9.43573 16.0012 9.65455 16.329 9.60233Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_12046_12082",
    x1: 2.96064,
    y1: 22.0905,
    x2: 20.4551,
    y2: 4.2891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEE411"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0518459,
    stopColor: "#FEDB16"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1381,
    stopColor: "#FEC125"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2481,
    stopColor: "#FE983D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3762,
    stopColor: "#FE5F5E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#FE2181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9000DC"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12046_12082"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.e5bb82518b82018f7c0c90ba9ab9884d.svg";
export { ForwardRef as ReactComponent };